import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';
import type {TranslationFunction} from 'src/types/language-support';
import {TZDate} from '@date-fns/tz';


export const selectCancellationPolicy = (
  state: IRootMachineSnapshot,
  t: TranslationFunction,
) => {
  const {timezone, eventDetails} = state.context;

  if (!eventDetails?.event_start) {
    return t('Event_not_found', 'Event not found');
  }

  const {event_start, did_cancellation_notice_pass, cancellation_policy} =
    eventDetails || {};

  const currentTime = new TZDate(new Date(), timezone).getTime();
  const eventStartTime = new TZDate(new Date(event_start), timezone).getTime();
  const isEventInFuture = currentTime < eventStartTime;

  if (cancellation_policy) {
    return cancellation_policy;
  }

  if (did_cancellation_notice_pass && !isEventInFuture) {
    return t(
      'This_meeting_does_not_exist_It_may_have_been_moved_or_deleted',
      'This meeting does not exist. It may have been moved or deleted.',
    );
  }

  if (did_cancellation_notice_pass && isEventInFuture) {
    return t(
      'This_meeting_is_too_close_to_cancel_using_the_link_Please_reach_out_to_the_host_directly',
      'This meeting is too close to cancel using the link. Please reach out to the host directly',
    );
  }

  return t('Cancel_period_is_over', 'Cancel period is over');
};

export const selectReason = (state: IRootMachineSnapshot) => {
  return state.context.reason;
};
